import React, {useRef} from "react";
import {useNavigate} from "react-router-dom";
import {escapeForRegex} from "../functions/helpers";
import {FadeInAnimation} from "./FadeInAnimation";

const {useEffect, useReducer, useState} = wp.element;

function theReducer(state, action) {
    switch (action.type) {
        case 'filterToggle':
            return {...state,
                tags:{
                    ...state.tags,
                    [action.item.slug]:{
                        ...state.tags[action.item.slug],
                        checked:!action.item.checked
                    }

                }
            }
        case 'searchChange':
            return {...state,
                search:action.value
            }
        case 'clearTags':
            return {...state,
                tags:{
                    ...NBIjs.tags //get original state of all tags
                }
            }
        default:
            break;
    }

    return state;
}

function CaseStudies(props) {
    const postsPerPage = 6;
    const navigate = useNavigate();

    const [theState, theAction] = useReducer(theReducer, {...NBIjs});
    const [searchState, searchAction] = useState({
        items:[]
    });
    const [uiState, uiAction] = useState({
        filters:false
    });

    const searchField = useRef(null); //we use ref and uncontrolled input field so it doesn't re-render search results whenever use types, only on submit

    /**
     * When clicked on tag
     * @param item
     */
    function onFilterToggle(item) {
        theAction({type:'filterToggle', item:item});
    }

    /**
     * When submitted search field form
     * @param e
     */
    function onSearchPhraseChange(e){
        e.preventDefault();
        theAction({type:'searchChange', value:searchField.current.value})
    }

    /**
     * Filter items based on fiters and search query. Save in search state.
     */
    function filterItems() {
        /*
            Whenever input changes filter out items that meet search / filter conditions
         */
        //Find enabled tags
        const enabledTags = {};
        Object.values(theState.tags).forEach((item)=>{ //get array of tag objects
            if (item.checked) {
                enabledTags[item.slug] = true;
            }
        });
        const hasTagsSelected = Object.keys(enabledTags).length > 0;

        //Search regex
        let searchRegex = null
        if (theState.search) {
            const words = theState.search.split(/\s+/);
            const regexStrings = words.map((word, w) => {
                return '(?=.*'+escapeForRegex(word)+')'
            })
            searchRegex = new RegExp('^'+regexStrings.join('')+'.*$', 'is');
            // console.log('search', theState.search, 'regex', searchRegex);
        }

        searchAction({
            ...searchState,
            items:theState.caseStudies.filter((caseStudy, i)=>{
                // check tags
                if (hasTagsSelected && caseStudy.tags) { //if case study has tags, an there are tags selected
                    //if there are no tags in case study that match selected filters
                    if (!caseStudy.tags.some((tag, t)=>{
                        return enabledTags[tag] === true;
                    })) { //if not found any of the selected tags in case study
                        return false;
                    }
                }

                //check search if any search phrase provide
                if (
                    theState.search &&
                    !(caseStudy.title.match(searchRegex) || caseStudy.content.match(searchRegex))
                ) {
                    return false; //if search phrase not found then exclude this case study
                }

                return true;
            }),
            page:0
        })
    }

    function loadVideo(videoURL) {
        jQuery('.video-overlay').addClass('active');
        jQuery('.video-overlay iframe').attr("src", videoURL);
        // console.log('caseStudy.videoURL', videoURL)
    }

    function CaseStudy(props) {
        const item = props.item;

        return (
            <FadeInAnimation className={'case-study'} direction={'up'}>
                <figure onClick={()=> {
                    loadVideo(item.videoURL)
                }}>
                    <img src={item.coverImage} alt={item.title} className='' width={16} height={9} />
                    {item.editLink &&
                    <a href={decodeURI(item.editLink)} className="clean-animation edit-post">Edit video</a>
                    }
                </figure>
                <header onClick={()=> {
                    loadVideo(item.videoURL)
                }}>
                    <h4>{item.title}</h4>
                </header>
                <article dangerouslySetInnerHTML={{__html:item.content}} />
            </FadeInAnimation>
        )
    }

    /**
     * Returns array of one page of products
     */
    function getPage() {
        let page = [];
        let item = null;
        const offset = searchState.page * postsPerPage;
        const maxItem = Math.min(offset + postsPerPage, searchState.items.length);

        for (let i=offset; i<maxItem ; i++) {
            item = searchState.items[i];
            page.push(
                <CaseStudy key={i} item={item} />
            );
        }
        return page;
    }

    /**
     * Returns paging markup
     * @returns {string|*[]}
     */
    function getPaging() {
        const totalPages = Math.ceil(searchState.items.length  / postsPerPage);
        if (totalPages <= 1) return '';
        const lastPage = totalPages - 1;
        let paging = [];

        if (searchState.page > 0) {
            paging.push(<button className="prev-page" onClick={()=>{searchAction({...searchState, page:searchState.page-1})}}>&nbsp;</button>);
        }

        for (let i=0; i<totalPages; i++) {
            paging.push(
                <button className={(i===searchState.page)?"active":""}  onClick={()=>{searchAction({...searchState, page:i})}}> {i+1} </button>
            )
        }

        if (searchState.page < lastPage) {
            paging.push(<button className="next-page" onClick={()=>{searchAction({...searchState, page:searchState.page+1})}}>&nbsp;</button>);
        }

        return paging;
    }
    /**
     * Does page have any tag filters on
     * @returns {boolean}
     */
    function hasFilters() {
        return Object.entries(theState.tags).some(([i, tag])=>{
            return tag.checked;
        })
    }

    /**
     * Clear al enabled tag filters
     */
    function clearTags() {
        theAction({type:'clearTags'});
    }

    function closeFilters(){
        jQuery('.search-form .tags').removeClass('active');
        jQuery('.filter-toggle').toggleClass('active');
        jQuery('.site.grid-container').removeClass('tags-active');
    }

    useEffect(() => {
        filterItems();
    }, [theState]);

    useEffect(() => {
        if (uiState.filters) {
            jQuery('.site.grid-container').addClass('tags-active');
        } else {
            jQuery('.site.grid-container').removeClass('tags-active');
        }
    }, [uiState.filters]);

    useEffect(() => {
        jQuery( 'html, body' ).animate( { scrollTop: jQuery('.site-main').offset().top } );
    }, [searchState]);



    return (
        <>
            <div className="container search-form scrollreveal" method="get">

                {/* Search Field */}
                <form className="search-field"  onSubmit={onSearchPhraseChange}>
                    <button type="submit" className="submit">&nbsp;</button>
                    <input type="text" name="search" maxLength="64" placeholder="Search" ref={searchField} />
                </form>


                {/* Filter Tags */}
                <button type="button" className={"filter-toggle"} ><span>Filter</span></button>
                <div className={"tags"} onClick={(e)=>{ e.stopPropagation(); }}>
                    <h3 className="mobile-only">Select filters</h3>
                    <div className="close-tags mobile-only" />
                    <fieldset>
                        {theState.tags &&
                        Object.entries(theState.tags).map(([i, item])=>{
                                return (
                                    <div className="tag" key={i}>
                                        <label>{item.name}
                                            <input type="checkbox" value={item.slug} checked={item.checked} onChange={(e)=> {
                                                e.stopPropagation();
                                                onFilterToggle(item)
                                            }} />
                                            <div className="checkbox" />
                                        </label>
                                    </div>
                                );
                            })
                        }
                        <button type="submit" className="button" onClick={closeFilters}>
                            Apply Filters
                        </button>
                    </fieldset>
                </div>
            </div>


            {/* Content / Search Results */}
            <div className="search-results">
                {/* Filter Info */}

                    <div className="filter-info container">
                        {theState.search &&
                        <h3 className="search-phrase">{theState.search}</h3>
                        }

                        {hasFilters() &&
                            <div class="search-tags">
                                {Object.entries(theState.tags)
                                    .filter(([i, tag])=>{
                                        return tag.checked;
                                    })
                                    .map(([i, tag])=>{
                                        return (
                                            <button className="tag">
                                                <span>{tag.name}</span>
                                                <span className="close-tag" onClick={()=>{onFilterToggle(tag)}}>&nbsp;</span>
                                            </button>
                                        )
                                    })
                                }
                                <div className="clear-tags tag">
                                    <span>Clear Keywords</span>
                                    <span className="close-tag" onClick={clearTags}>&nbsp;</span>
                                </div>
                            </div>
                        }
                    </div>




                {/* Search Items loop */}
                <div className="container search-items">
                    {searchState.items &&
                        getPage()
                    }
                </div>

                {/* Paging */}
                <div className="paging container">
                    {getPaging()}
                </div>
            </div>
        </>
    );
}

export { CaseStudies }
